import { SourceData } from '@/components/control/TableSelectBox'

class SelectUtil {
    private _data: SourceData[]

    constructor ( data: SourceData[] )  {
        this._data = data
    }

    printName ( value: string ): string {
        return this._data?.find( f => f.value === value )?.name || ''
    }

    static create ( data: SourceData[] ) {
        return new SelectUtil( data )
    }

}

export default SelectUtil
